import { useEffect, useRef } from "react";
import { sortingKeys, sortingModes } from "constants/dictionary";
import {
  sortObjectsByBooleanField,
  sortObjectsByDateField,
  sortObjectsByTextField,
} from "utils/dictionary";

export const useSorting = (
  sortedBy,
  sortingMode,
  dictionaries,
  setSortedDictionaries
) => {
  const isFirstSorting = useRef(true);

  useEffect(() => {
    // We recieving sorted data from backend, so no need to sort it again
    if (isFirstSorting.current) {
      isFirstSorting.current = false;
      return;
    }

    const ascending = sortingMode === sortingModes.ascending;

    switch (sortedBy) {
      case sortingKeys.name:
        setSortedDictionaries(
          sortObjectsByTextField([...dictionaries], sortingKeys.name, ascending)
        );
        break;
      case sortingKeys.createdBy:
        setSortedDictionaries(
          sortObjectsByTextField(
            [...dictionaries].map((dictionary) => {
              if (!dictionary.createdBy) {
                return {
                  ...dictionary,
                  createdBy: "System",
                };
              }
              return dictionary;
            }),
            sortingKeys.createdBy,
            ascending
          )
        );
        break;
      case sortingKeys.createdOn:
        setSortedDictionaries(
          sortObjectsByDateField(
            [...dictionaries],
            sortingKeys.createdOn,
            ascending
          )
        );
        break;
      case sortingKeys.lastUpdated:
        setSortedDictionaries(
          sortObjectsByDateField(
            [...dictionaries],
            sortingKeys.lastUpdated,
            ascending
          )
        );
        break;
      case sortingKeys.inUse:
        setSortedDictionaries(
          sortObjectsByBooleanField(
            [...dictionaries],
            sortingKeys.inUse,
            ascending
          )
        );
        break;
      default:
        break;
    }
  }, [sortedBy, sortingMode]);
};
